(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["onima-pdp-gallery"] && !Shopify.designMode) return;
  try {
    (() => {
 const init = root => {
  root.querySelectorAll('[data-on-pilot-gallery]').forEach(gallery => {
   if (gallery.dataset.ready) return;
   gallery.dataset.ready = 'true';
   const slides = [...gallery.querySelectorAll('[data-on-gallery-slide]')];
   const buttons = [...gallery.querySelectorAll('[data-on-gallery-select]')];
   const dialog = gallery.querySelector('dialog');
   let current = 0;
   const choose = index => {
    current = (index + slides.length) % slides.length;
    slides.forEach((slide, i) => {
     slide.hidden = i !== current;
     if (i === current) slide.querySelector('img').loading = 'eager';
    });
    buttons.forEach((button, i) => button.setAttribute('aria-pressed', String(i === current)));
   };
   gallery.addEventListener('click', event => {
    const select = event.target.closest('[data-on-gallery-select]');
    if (select) choose(Number(select.dataset.onGallerySelect));
    const open = event.target.closest('[data-on-gallery-open]');
    if (open && dialog.showModal) {
     event.preventDefault();
     const original = open.querySelector('img'), image = dialog.querySelector('img');
     image.src = original.currentSrc || original.src;
     image.alt = original.alt;
     image.width = original.naturalWidth;
     image.height = original.naturalHeight;
     dialog.showModal();
    }
    if (event.target.closest('[data-on-gallery-close]')) dialog.close();
    if (event.target === dialog) dialog.close();
   });
   gallery.addEventListener('keydown', event => {
    if (!event.target.closest('[data-on-gallery-select]') || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    choose(current + (event.key === 'ArrowRight' ? 1 : -1));
    buttons[current].focus();
   });
  });
 };
 const start = () => init(document);
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
 document.addEventListener('shopify:section:load', event => init(event.target));
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["onima-subscription-options"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => document.querySelectorAll('[data-on-subscription]').forEach(root => {
    if (root.dataset.initialized) return;
    const form = root.closest('form');
    const quantity = form?.querySelector('[name="quantity"]');
    const button = form?.querySelector('[type="submit"]');
    if (!form || !quantity || !button) return;
    root.dataset.initialized = 'true';
    const initiallyDisabled = button.disabled;
    const plan = root.querySelector('[data-on-sub-plan]');
    const cadenceInputs = [...root.querySelectorAll('[data-on-sub-cadence]')];
    const purchase = form.closest('.shopify-section') || form.parentElement;
    const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency});
    const mode = () => root.querySelector('[data-on-sub-mode]:checked')?.value === 'subscription';
    const selected = () => root.querySelector('[data-on-sub-cadence]:checked');
    const ready = () => Boolean(selected()?.dataset.plan);
    const render = () => {
      const recurring = mode();
      const option = selected() || cadenceInputs.find(input => input.dataset.plan);
      const unit = Number(root.dataset.oncePrice);
      const recurringUnit = Number(option?.dataset.price || unit);
      const count = Math.max(1, Number(quantity.value) || 1);
      root.querySelector('[data-on-sub-details]').hidden = !recurring;
      root.querySelector('[data-on-once-total]').textContent = money.format(unit * count / 100);
      root.querySelector('[data-on-compare-total]').textContent = money.format(unit * count / 100);
      root.querySelector('[data-on-recurring-total]').textContent = money.format(recurringUnit * count / 100);
      root.querySelector('[data-on-sub-error]').hidden = !recurring || ready();
      plan.disabled = !recurring || !ready();
      plan.value = recurring && ready() ? selected().dataset.plan : '';
      button.disabled = initiallyDisabled || (recurring && !ready());
      purchase.querySelectorAll('[data-on-sub-price], .on-pdp-price > span').forEach(el => { el.textContent = money.format((recurring ? recurringUnit : unit) / 100); });
      purchase.querySelectorAll('[data-on-sub-price-label], .on-pdp-price > small').forEach(el => { el.textContent = recurring ? root.dataset.recurringLabel : root.dataset.onceLabel; });
      form.querySelectorAll('[data-on-quantity-step]').forEach(control => {
        control.disabled = initiallyDisabled || (Number(control.dataset.onQuantityStep) < 0 ? count <= 1 : count >= Number(quantity.max || 99));
      });
    };
    root.querySelectorAll('[data-on-sub-mode]').forEach(input => { input.disabled = initiallyDisabled || (input.value === 'subscription' && !cadenceInputs.some(option => option.dataset.plan)); });
    root.addEventListener('change', render);
    quantity.addEventListener('input', render);
    quantity.addEventListener('change', render);
    form.querySelectorAll('[data-on-quantity-step]').forEach(control => control.addEventListener('click', () => {
      const count = Math.min(Number(quantity.max || 99), Math.max(1, (Number(quantity.value) || 1) + Number(control.dataset.onQuantityStep)));
      quantity.value = String(count);
      quantity.dispatchEvent(new Event('input', {bubbles:true}));
    }));
    form.addEventListener('submit', event => {
      if (mode() && !ready()) {
        event.preventDefault();
        event.stopImmediatePropagation();
        root.querySelector('[data-on-sub-error]').hidden = false;
        cadenceInputs.find(input => !input.disabled)?.focus();
      }
    }, true);
    render();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["onima-system"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.onimaDraftInitialized) return;
  window.onimaDraftInitialized = true;
  const start = () => {
    const initScenes = () => {
      document.querySelectorAll('[data-on-scene][data-on-motion-enabled]').forEach(scene => {
        if (scene.dataset.motionReady || !window.CSS?.supports('animation-timeline: view()')) return;
        const control = scene.querySelector('[data-on-motion]');
        if (!control) return;
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const syncMotion = () => {
          const enabled = !reduced.matches && scene.dataset.userMotion !== 'off';
          scene.dataset.motion = enabled ? 'on' : 'off';
          control.setAttribute('aria-pressed', String(enabled));
        };
        scene.dataset.motionReady = 'true';
        syncMotion();
        reduced.addEventListener('change', syncMotion);
      });
    };
    initScenes();
    document.addEventListener('shopify:section:load', initScenes);
    const initProductShortcut = () => {
      const shortcut = document.querySelector('[data-on-pdp-float]');
      const purchase = document.querySelector('.on-pdp-buy .on-buy');
      if (!shortcut || !purchase || shortcut.dataset.observed || !('IntersectionObserver' in window)) return;
      shortcut.dataset.observed = 'true';
      new IntersectionObserver(entries => {
        shortcut.hidden = entries[0].isIntersecting;
      }, { rootMargin: '-75px 0px -80px 0px' }).observe(purchase);
    };
    initProductShortcut();
    document.addEventListener('shopify:section:load', initProductShortcut);
    const root = document.body.dataset.onRoot || '/';
    const messages = JSON.parse(document.getElementById('onima-strings')?.textContent || '{}');
    const cartUrl = root + 'cart';
    const updateCount = async () => {
      const response = await fetch(cartUrl + '.js', {headers:{Accept:'application/json'}});
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-on-count]').forEach(el => { el.textContent = cart.item_count; });
    };
    document.addEventListener('theme:cart:change', event => {
      const count = event.detail?.cartCount;
      if (Number.isInteger(count)) document.querySelectorAll('[data-on-count]').forEach(el => { el.textContent = count; });
    });
    window.addEventListener('pageshow', event => { if (event.persisted) updateCount().catch(() => {}); });
    const showStatus = (element, text, success) => {
      if (!element) return;
      element.replaceChildren(document.createTextNode(text));
      element.classList.toggle('is-error', !success);
      if (success && text === messages.added) {
        const link = document.createElement('a');
        link.href = cartUrl;
        link.textContent = messages.bag;
        element.appendChild(link);
      }
    };
    const postCart = async body => {
      const response = await fetch(cartUrl + '/add.js', {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || messages.error);
      return result;
    };
    document.addEventListener('submit', async event => {
      const form = event.target.closest('[data-on-form]');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('button[type=submit]');
      if (button.disabled) return;
      const label = button.querySelector('span');
      const oldLabel = label.textContent;
      const status = form.querySelector('.on-form-status');
      const data = new FormData(form);
      const item = {id:Number(data.get('id')),quantity:Number(data.get('quantity'))};
      if (!Number.isInteger(item.quantity) || item.quantity < 1) return;
      if (data.get('selling_plan')) item.selling_plan = Number(data.get('selling_plan'));
      button.disabled = true;
      const variantPicker = form.querySelector('[data-on-kit-variant]');
      if (variantPicker) variantPicker.disabled = true;
      label.textContent = messages.adding;
      showStatus(status,'',true);
      try {
        await postCart({items:[item]});
        showStatus(status,messages.added,true);
        await updateCount();
      } catch (error) {
        showStatus(status,error.message || messages.error,false);
      } finally {
        if (variantPicker) variantPicker.disabled = false;
        button.disabled = false;
        label.textContent = oldLabel;
      }
    }, true);
    const setMode = mode => {
      document.querySelectorAll('[data-on-shop]').forEach(shop => {
        const build = mode === 'build';
        shop.querySelectorAll('[data-on-mode]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.onMode === mode)));
        shop.querySelectorAll('.on-build-controls,.on-build-summary,.on-build-note').forEach(el => { el.hidden = !build; });
        shop.querySelectorAll('.on-single-controls').forEach(el => { el.hidden = build; });
      });
    };
    document.addEventListener('click', event => {
      const motion = event.target.closest('[data-on-motion]');
      if (motion) {
        const enabled = motion.getAttribute('aria-pressed') !== 'true';
        motion.setAttribute('aria-pressed', String(enabled));
        motion.closest('[data-on-scene]').dataset.motion = enabled ? 'on' : 'off';
        motion.closest('[data-on-scene]').dataset.userMotion = enabled ? 'on' : 'off';
      }
      const button = event.target.closest('[data-on-mode]');
      if (button) setMode(button.dataset.onMode);
      const buildLink = event.target.closest('[data-on-build-link]');
      if (buildLink) setMode('build');
      const menuLink = event.target.closest('.on-mobile-menu a');
      if (menuLink) menuLink.closest('details').open = false;
      const flavor = event.target.closest('[data-on-flavor]');
      if (flavor) {
        const finder = flavor.closest('[data-on-finder]');
        finder.querySelectorAll('[data-on-flavor]').forEach(el => el.setAttribute('aria-pressed',String(el === flavor)));
        finder.querySelectorAll('[data-on-flavor-panel]').forEach(el => { el.hidden = el.dataset.onFlavorPanel !== flavor.dataset.onFlavor; });
      }
    });
    const updateSelection = shop => {
      let count=0,subtotal=0;
      shop.querySelectorAll('[data-on-build-qty]').forEach(input => {
        if(input.disabled)return;
        const max=Number(input.max)||99;
        const qty=Math.min(max,Math.max(0,Math.floor(Number(input.value)||0)));
        input.value=String(qty);
        count+=qty;
        subtotal+=qty*Number(input.dataset.price);
      });
      shop.querySelector('[data-on-selection-count]').textContent=String(count);
      shop.querySelector('[data-on-selection-total]').textContent=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currencyDisplay:'narrowSymbol',currency:shop.dataset.currency||'USD'}).format(subtotal/100);
      shop.querySelector('[data-on-add-selection]').disabled=count===0;
    };
    document.addEventListener('input', event => {
      if(event.target.matches('[data-on-build-qty]'))updateSelection(event.target.closest('[data-on-shop]'));
    });
    document.addEventListener('click', async event => {
      const button=event.target.closest('[data-on-add-selection]');
      if(!button||button.disabled)return;
      const shop=button.closest('[data-on-shop]');
      const status=shop.querySelector('.on-build-status');
      const inputs=[...shop.querySelectorAll('[data-on-build-qty]')];
      const items=inputs.filter(el=>!el.disabled&&Number(el.value)>0).map(el=>({id:Number(el.dataset.variant),quantity:Number(el.value)}));
      if(!items.length){showStatus(status,messages.empty,false);return;}
      button.disabled=true;
      showStatus(status,messages.adding,true);
      try{
        await postCart({items});
        showStatus(status,messages.added,true);
        inputs.forEach(input=>{input.value='0';});
        updateSelection(shop);
        await updateCount();
      }catch(error){
        showStatus(status,error.message||messages.error,false);
        updateSelection(shop);
      }
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape')document.querySelectorAll('.on-mobile-menu[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});
    });
    window.addEventListener('hashchange',()=>{if(location.hash==='#build-your-own')setMode('build');});
    if(location.hash==='#build-your-own')setMode('build');
    document.addEventListener('shopify:section:load',()=>{if(location.hash==='#build-your-own')setMode('build');});
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();

(() => {
  if (window.onimaBundleStudioInitialized) return;
  window.onimaBundleStudioInitialized = true;
  const active = new Map();
  const init = root => {
    root.querySelectorAll('[data-on-bundle-studio]').forEach(studio => {
      if (active.has(studio)) return;
      const strings = JSON.parse(studio.querySelector('[data-on-mix-strings]').textContent);
      const panels = [...studio.querySelectorAll('[data-on-mix-panel]')];
      const flavors = [...studio.querySelectorAll('[data-on-mix-flavor]')];
      const slots = [...studio.querySelectorAll('[data-on-mix-slot]')];
      const status = studio.querySelector('[data-on-mix-status]');
      const review = studio.querySelector('[data-on-mix-review]');
      const reviewPanel = studio.querySelector('[data-on-mix-review-panel]');
      const reset = studio.querySelector('[data-on-mix-reset]');
      const purchase = studio.querySelector('[data-on-mix-purchase]');
      const purchaseStatus = studio.querySelector('[data-on-mix-purchase-status]');
      const bundleReady = studio.dataset.bundleReady === 'true' && !!studio.dataset.bundleVariant;
      let purchasing = false;
      const motion = studio.querySelector('[data-on-mix-motion]');
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      const finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
      const byId = new Map(panels.map(panel => [panel.dataset.onMixPanel, panel]));
      if (!panels.length) return;
      const flights = new Map(), imageLoads = new Map(), loadedMeters = new WeakSet();
      let selected = [], current = panels[0], userMotion = true, frame = 0, pointerFrame = 0, visible = false;
      let pointerX = 0, pointerY = 0, imagesPreloaded = false;
      const inViewport = (element, fully = false) => {
        if (!element || !element.isConnected) return false;
        const rect = element.getBoundingClientRect();
        if (!rect.width || !rect.height) return false;
        return fully
          ? rect.top >= 0 && rect.left >= 0 && rect.bottom <= innerHeight && rect.right <= innerWidth
          : rect.bottom > 0 && rect.right > 0 && rect.top < innerHeight && rect.left < innerWidth;
      };
      const countText = () => selected.length + ' ' + strings.selected;
      const say = text => { status.textContent = text + ' ' + countText() + '.'; };
      const canMove = () => userMotion && !reduced.matches;
      const canAnimate = () => canMove() && visible && !document.hidden;
      const playBottle = panel => {
        if (panel !== current || !studio.isConnected || !canAnimate() || !inViewport(panel.querySelector('.on-mix-stage'))) return;
        panel.classList.remove('is-changing');
        void panel.offsetWidth;
        panel.classList.add('is-changing');
      };
      const waitForBottle = panel => {
        const image = panel.querySelector('img.on-mix-photo');
        if (!image || imageLoads.has(image)) return;
        if (image.complete && image.naturalWidth) { playBottle(panel); return; }
        const loaded = event => {
          image.removeEventListener('load', loaded); image.removeEventListener('error', loaded); imageLoads.delete(image);
          if (event.type === 'load' && image.complete && image.naturalWidth) playBottle(panel);
        };
        imageLoads.set(image, loaded);
        image.addEventListener('load', loaded); image.addEventListener('error', loaded);
        image.loading = 'eager';
      };
      const preloadBottles = () => {
        if (imagesPreloaded || !visible || document.hidden) return;
        imagesPreloaded = true;
        waitForBottle(current);
        panels.forEach(panel => { const image = panel.querySelector('img.on-mix-photo'); if (image) image.loading = 'eager'; });
      };
      const stopFlights = () => {
        flights.forEach((clone, animation) => { animation.cancel(); clone.remove(); });
        flights.clear();
      };
      const resetPointer = () => {
        cancelAnimationFrame(pointerFrame); pointerFrame = 0;
        pointerX = 0; pointerY = 0;
        panels.forEach(panel => {
          const stage = panel.querySelector('.on-mix-stage');
          stage.style.setProperty('--mix-pointer-x', '0');
          stage.style.setProperty('--mix-pointer-y', '0');
        });
      };
      const playMeters = (panel = current) => {
        const meters = panel.querySelector('.on-mix-meters');
        if (!meters || panel !== current || loadedMeters.has(meters) || !canAnimate() || !inViewport(meters)) return;
        meters.classList.remove('is-loading');
        void meters.offsetWidth;
        meters.classList.add('is-loading');
        loadedMeters.add(meters);
      };
      const updateScroll = () => {
        frame = 0;
        if (!studio.isConnected || !canAnimate()) return;
        const stage = current.querySelector('.on-mix-stage').getBoundingClientRect();
        const progress = Math.max(0, Math.min(1, (innerHeight - stage.top) / (innerHeight + stage.height)));
        studio.style.setProperty('--mix-progress', progress.toFixed(4));
      };
      const schedule = () => { if (!frame && canAnimate()) frame = requestAnimationFrame(updateScroll); };
      const syncVisibility = () => {
        studio.dataset.visible = String(visible && !document.hidden);
        preloadBottles();
        if (!canAnimate()) {
          cancelAnimationFrame(frame); frame = 0;
          resetPointer(); stopFlights();
        } else { schedule(); playMeters(); }
      };
      const syncMotion = () => {
        const enabled = canMove();
        studio.dataset.motion = enabled ? 'on' : 'off';
        motion.setAttribute('aria-pressed', String(enabled));
        motion.textContent = enabled ? strings.motionOn : strings.motionOff;
        motion.disabled = reduced.matches;
        if (!enabled) {
          cancelAnimationFrame(frame); frame = 0;
          studio.style.setProperty('--mix-progress', '.5');
          resetPointer(); stopFlights();
          panels.forEach(panel => {
            panel.classList.remove('is-changing');
            panel.querySelector('.on-mix-meters')?.classList.remove('is-loading');
          });
          slots.forEach(slot => slot.classList.remove('is-added'));
        } else { schedule(); playMeters(); }
      };
      const flyToSlot = (panel, index) => {
        const source = panel.querySelector('img.on-mix-photo, .on-mix-photo img');
        const slot = slots[index];
        if (!canAnimate() || !source?.complete || !source.naturalWidth) return;
        if (!source.animate || !inViewport(source, true) || !inViewport(slot, true)) {
          if (inViewport(source)) { panel.classList.remove('is-changing'); void panel.offsetWidth; panel.classList.add('is-changing'); }
          return;
        }
        slot.classList.remove('is-added');
        const target = slot.querySelector('img');
        if (!target) return;
        const from = source.getBoundingClientRect(), to = target.getBoundingClientRect();
        const dx = to.left + to.width / 2 - from.left - from.width / 2;
        const dy = to.top + to.height / 2 - from.top - from.height / 2;
        const scale = Math.min(to.width / from.width, to.height / from.height);
        const clone = source.cloneNode(false);
        clone.removeAttribute('id'); clone.removeAttribute('srcset'); clone.removeAttribute('sizes');
        clone.removeAttribute('loading'); clone.src = source.currentSrc || source.src;
        clone.className = 'on-mix-flying-bottle'; clone.alt = ''; clone.setAttribute('aria-hidden', 'true');
        Object.assign(clone.style, {position:'fixed', left:from.left+'px', top:from.top+'px', width:from.width+'px', height:from.height+'px', margin:'0', pointerEvents:'none', zIndex:'1000', objectFit:'contain', transformOrigin:'center', background:'transparent', border:'0'});
        document.body.appendChild(clone);
        const animation = clone.animate([
          {transform:'translate3d(0,0,0) scale(1) rotate(0deg)', opacity:1},
          {transform:'translate3d('+(dx*.43)+'px,'+(dy*.35-55)+'px,0) scale(.76) rotate(-13deg)', opacity:1, offset:.46},
          {transform:'translate3d('+dx+'px,'+dy+'px,0) scale('+scale+') rotate(0deg)', opacity:.85}
        ], {duration:760, easing:'cubic-bezier(.2,.72,.26,1)', fill:'forwards'});
        flights.set(animation, clone);
        animation.finished.then(() => {
          if (canAnimate() && selected[index] === panel.dataset.onMixPanel) {
            slot.classList.remove('is-added'); void slot.offsetWidth; slot.classList.add('is-added');
          }
        }).catch(() => {}).finally(() => { clone.remove(); flights.delete(animation); });
      };
      const render = addedIndex => {
        stopFlights();
        slots.forEach((slot, index) => {
          slot.replaceChildren(); slot.classList.remove('is-added', 'is-filled');
          const id = selected[index];
          if (!id) {
            const mark = document.createElement('span'); mark.textContent = '+'; mark.setAttribute('aria-hidden', 'true');
            const label = document.createElement('small'); label.textContent = strings.empty;
            slot.append(mark, label); slot.style.removeProperty('--slot-tint');
            return;
          }
          const panel = byId.get(id);
          slot.classList.add('is-filled');
          slot.style.setProperty('--slot-tint', panel.dataset.tint);
          const image = document.createElement('img'); image.src = panel.dataset.slotImage; image.alt = ''; image.width = 70; image.height = 70;
          const label = document.createElement('strong'); label.textContent = panel.dataset.name;
          const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.onMixRemove = String(index);
          remove.textContent = '×'; remove.setAttribute('aria-label', strings.remove + ' ' + panel.dataset.name + ' (' + (index + 1) + ')');
          slot.append(image, label, remove);
          if (index === addedIndex && canAnimate()) slot.classList.add('is-added');
        });
        studio.querySelector('[data-on-mix-count]').textContent = countText();
        panels.forEach(panel => {
          const add = panel.querySelector('[data-on-mix-add]');
          if (!add) return;
          const qty = selected.filter(id => id === panel.dataset.onMixPanel).length;
          const limit = Number(panel.dataset.limit);
          const eligible = panel.dataset.bundleEligible !== 'false';
          add.disabled = !bundleReady || !eligible || selected.length >= 4 || qty >= limit;
          add.textContent = !eligible ? (panel.dataset.available === 'true' ? strings.separate : strings.soldOut) : limit === 0 ? strings.soldOut : selected.length >= 4 ? strings.full : qty >= limit ? strings.stockLimit : qty > 0 ? strings.another : strings.add;
        });
        review.disabled = !bundleReady || selected.length !== 4;
        reset.hidden = !selected.length;
        reviewPanel.hidden = true;
        purchaseStatus.textContent = '';
        if (!bundleReady) status.textContent = strings.unavailable;
        review.setAttribute('aria-expanded', 'false');
      };
      const choose = button => {
        const panel = byId.get(button.dataset.onMixFlavor);
        if (!panel || panel === current) return;
        stopFlights(); resetPointer();
        current.classList.remove('is-changing');
        current = panel;
        panels.forEach(item => { item.hidden = item !== panel; });
        flavors.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        studio.style.setProperty('--mix-tint', panel.dataset.tint);
        studio.style.setProperty('--mix-accent', panel.dataset.accent);
        const meters = panel.querySelector('.on-mix-meters');
        if (meters) { loadedMeters.delete(meters); meters.classList.remove('is-loading'); }
        panel.classList.remove('is-changing');
        waitForBottle(panel);
        status.textContent = panel.dataset.name + '. ' + panel.dataset.word + '. ' + countText() + '.';
        playMeters(panel);
        schedule();
      };
      const onClick = async event => {
        if (purchasing) return;
        if (event.target.closest('[data-on-mix-purchase]')) {
          if (!bundleReady || selected.length !== 4) return;
          const tokens = selected.map(id => byId.get(id)?.dataset.selectionToken);
          if (tokens.some(token => !token)) { purchaseStatus.textContent = strings.unavailable; return; }
          purchasing = true;
          purchase.disabled = true;
          purchase.textContent = strings.addingToBag;
          purchaseStatus.textContent = '';
          studio.setAttribute('aria-busy', 'true');
          try {
            const response = await fetch(studio.dataset.cartAddUrl, {
              method: 'POST',
              headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
              body: JSON.stringify({items:[{
                id: Number(studio.dataset.bundleVariant),
                quantity: 1,
                properties: {_bundle_selection: tokens.sort().join(' <> ')}
              }]})
            });
            const result = await response.json();
            if (!response.ok || result.status >= 400) {
              const description = typeof result.description === 'string' ? result.description : '';
              throw new Error(description || strings.purchaseError);
            }
            window.location.assign(studio.dataset.cartUrl);
          } catch (error) {
            purchaseStatus.textContent = error.message || strings.purchaseError;
            purchase.disabled = false;
            purchase.textContent = strings.purchase;
            purchasing = false;
            studio.removeAttribute('aria-busy');
          }
          return;
        }
        const flavor = event.target.closest('[data-on-mix-flavor]');
        if (flavor) { choose(flavor); return; }
        if (event.target.closest('[data-on-mix-motion]')) { userMotion = !userMotion; syncMotion(); return; }
        const add = event.target.closest('[data-on-mix-add]');
        if (add && !add.disabled) {
          const id = add.dataset.onMixAdd, panel = byId.get(id);
          if (!panel || panel.dataset.bundleEligible === 'false' || selected.length >= 4 || selected.filter(item => item === id).length >= Number(panel.dataset.limit)) return;
          selected.push(id); render(selected.length - 1); say(panel.dataset.name + '. ' + strings.added);
          flyToSlot(panel, selected.length - 1);
          return;
        }
        const remove = event.target.closest('[data-on-mix-remove]');
        if (remove) {
          const index = Number(remove.dataset.onMixRemove), panel = byId.get(selected[index]);
          if (!panel) return;
          selected.splice(index, 1); render(); say(panel.dataset.name + '. ' + strings.removed);
          const next = slots[Math.min(index, selected.length - 1)]?.querySelector('button');
          (next || current.querySelector('.on-mix-add')).focus({preventScroll:true});
          return;
        }
        if (event.target.closest('[data-on-mix-reset]')) {
          selected = []; render(); say(strings.cleared); current.querySelector('.on-mix-add').focus({preventScroll:true}); return;
        }
        if (event.target.closest('[data-on-mix-review]') && selected.length === 4) {
          const list = studio.querySelector('[data-on-mix-review-list]'); list.replaceChildren();
          const quantities = new Map();
          selected.forEach(id => quantities.set(id, (quantities.get(id) || 0) + 1));
          quantities.forEach((qty, id) => {
            const item = document.createElement('li'); item.textContent = qty + ' × ' + byId.get(id).dataset.name; list.appendChild(item);
          });
          reviewPanel.hidden = false; review.setAttribute('aria-expanded', 'true');
          studio.querySelector('[data-on-mix-review-title]').focus({preventScroll:true});
          reviewPanel.scrollIntoView({behavior:canMove()?'smooth':'instant',block:'nearest'});
        }
      };
      const onPointerMove = event => {
        if (event.pointerType !== 'mouse' || !finePointer.matches || !canAnimate()) return;
        const stage = current.querySelector('.on-mix-stage');
        if (!stage.contains(event.target)) { resetPointer(); return; }
        const rect = stage.getBoundingClientRect();
        pointerX = Math.max(-1, Math.min(1, ((event.clientX - rect.left) / rect.width - .5) * 2));
        pointerY = Math.max(-1, Math.min(1, ((event.clientY - rect.top) / rect.height - .5) * 2));
        if (!pointerFrame) pointerFrame = requestAnimationFrame(() => {
          pointerFrame = 0;
          if (!canAnimate() || !finePointer.matches) return;
          stage.style.setProperty('--mix-pointer-x', pointerX.toFixed(3));
          stage.style.setProperty('--mix-pointer-y', pointerY.toFixed(3));
        });
      };
      const onScroll = () => {
        if (!observer) { visible = inViewport(studio); syncVisibility(); }
        schedule();
      };
      const onResize = () => { resetPointer(); stopFlights(); onScroll(); };
      const onVisibilityChange = () => { visible = inViewport(studio); syncVisibility(); };
      studio.addEventListener('click', onClick);
      studio.addEventListener('pointermove', onPointerMove, {passive:true});
      studio.addEventListener('pointerleave', resetPointer);
      window.addEventListener('scroll', onScroll, {passive:true});
      window.addEventListener('resize', onResize, {passive:true});
      document.addEventListener('visibilitychange', onVisibilityChange);
      reduced.addEventListener('change', syncMotion);
      finePointer.addEventListener('change', resetPointer);
      let observer, meterObserver;
      visible = inViewport(studio);
      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; syncVisibility(); });
        observer.observe(studio);
        meterObserver = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.isIntersecting) playMeters(entry.target.closest('[data-on-mix-panel]')); });
        }, {threshold:.15});
        panels.forEach(panel => { const meters = panel.querySelector('.on-mix-meters'); if (meters) meterObserver.observe(meters); });
      }
      flavors.forEach(button => { button.disabled = false; });
      motion.hidden = false;
      studio.dataset.ready = 'true';
      render(); syncMotion(); syncVisibility();
      active.set(studio, () => {
        cancelAnimationFrame(frame); resetPointer(); stopFlights(); observer?.disconnect(); meterObserver?.disconnect();
        imageLoads.forEach((loaded, image) => { image.removeEventListener('load', loaded); image.removeEventListener('error', loaded); });
        imageLoads.clear();
        studio.dataset.visible = 'false';
        studio.removeEventListener('click', onClick);
        studio.removeEventListener('pointermove', onPointerMove); studio.removeEventListener('pointerleave', resetPointer);
        window.removeEventListener('scroll', onScroll); window.removeEventListener('resize', onResize);
        document.removeEventListener('visibilitychange', onVisibilityChange);
        reduced.removeEventListener('change', syncMotion); finePointer.removeEventListener('change', resetPointer); active.delete(studio);
      });
    });
  };
  const start = () => init(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    active.forEach((cleanup, studio) => { if (event.target.contains(studio)) cleanup(); });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
